<template>
  <div class="container">
    <!-- 网吧信息管理 -->
    <div class="info-management">
      <!-- 场所 -->
      <div class="place-name clearfix">
        <span>场所名称</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.siteName" />
        </span>
      </div>
      <div class="place-name clearfix">
        <span>场所地址</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.siteAddress" />
        </span>
      </div>
      <div class="place-name clearfix">
        <span>场所联系电话</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.principalTel" />
        </span>
      </div>
      <!-- 营业状态 -->
      <div class="place-name clearfix">
        <span>营业状态</span>
        <span class="select" @click="handleBusinessStatusShow">
          <span v-if="echoData.siteState == 1">装机开业</span>
          <span v-if="echoData.siteState == 2">装机停业</span>
          <span v-if="echoData.siteState == 3">未装机开业</span>
          <span v-if="echoData.siteState == 4">未装机停业</span>
          <span v-if="echoData.siteState == 5">其他</span>
          <img src="@/images/right.png" alt srcset />
        </span>
      </div>
      <!-- 负责人姓名 -->
      <div class="place-name clearfix">
        <span>负责人姓名</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.infomanName" />
        </span>
      </div>
      <div class="place-name clearfix">
        <span>安全员姓名</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.principalName" />
        </span>
      </div>
      <div class="place-name clearfix">
        <span>负责人联系电话</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.principalTel" />
        </span>
      </div>
      <div class="place-name clearfix">
        <span>负责人(安全员)E-mail</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.principalEmail" />
        </span>
      </div>
      <div class="place-name clearfix">
        <span>上网终端数量</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.netterminalsNum" />
        </span>
      </div>
      <div class="place-name clearfix">
        <span>运营商</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.connectmode" />
        </span>
      </div>
      <!-- 管辖地派出所 -->
      <div class="place-name clearfix" @click="handlePoliceShow">
        <span>管辖地派出所</span>
        <span class="select">
          {{echoData.policeName}}
          <img src="@/images/right.png" alt srcset />
        </span>
      </div>
      <div class="place-name clearfix">
        <span>起始IP地址</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.fromIp" />
        </span>
      </div>
      <div class="place-name clearfix">
        <span>结束IP地址</span>
        <span>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.toIp" />
        </span>
      </div>
      <div class="place-name clearfix" @click="handleSelectLatlng">
        <span>经纬度</span>
        <span class="select">
          {{echoData.latlng}}
          <img src="@/images/right.png" alt srcset />
        </span>
      </div>
      <!-- 组织机构代码 -->
      <div class="place-code clearfix">
        <div>安全管理系统厂家组织机构代码</div>
        <div>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.securitySoftwareOrgcode" />
        </div>
      </div>
      <!-- 系统厂家名称 -->
      <div class="place-code clearfix">
        <div>安全管理系统厂家名称</div>
        <div>
          <input v-reset-page  type="text" placeholder="请输入" v-model="echoData.securitySoftwareOrgname" />
        </div>
      </div>
    </div>
    <div class="btn" @click="handleSaveNetbarInfo">保存</div>
    <!-- 保修类型选择 -->
    <van-popup v-model="statusShow" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        :columns="columns"
        confirm-button-text="完成"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
    <!-- 派出所选择 -->
    <van-popup v-model="policeShow" position="top" :overlay="true">
      <van-tree-select
        :items="items"
        :active-id.sync="items.activeId"
        :main-active-index.sync="items.activeId"
        @click-nav="onNavClick" 
      >
        <template slot="content" >
          <!-- v-if="activeIndex === 0" -->
          <ul class="right-content">
            <li v-for="(item,index) in policeList" :key="index" :class="{active:policeCode==item.policeCode}"  @click="onItemClick(item.policeName,item.policeCode)"> {{item.policeName}} </li>
          </ul>
          <!-- <ul v-if="activeIndex === 1" class="right-content">
            <li>东方广场派出所1</li>
            <li>东方广场派出所1</li>
            <li>东方广场派出所1</li>
            <li>东方广场派出所1</li>
            <li>东方广场派出所1</li>
            <li>东方广场派出所1</li>
          </ul> -->
        </template>
      </van-tree-select>
      <div class="btn" @click="onPoliceClick">完成</div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from "vant";
import { Picker } from "vant";
import { TreeSelect } from "vant";
import { Toast } from "vant"
import { netbarInfo ,echonNetbarInfo} from "@/api/info";
import { branchInfo,PoliceList } from "@/api/public";
import { debuglog } from 'util';

export default {
  components: {
    vanPopup: Popup,
    vanPicker: Picker,
    vanTreeSelect: TreeSelect
  },
  data() {
    return {
      columns: [],
      statusShow: false,
      policeShow: false,
      items: [],
      activeId: 0,
      activeIndex: 0,
      echoData: {},
      policeList:[],
      policeCode:'',
      internetBarId:''
    };
  },
  mounted() {
    this.requestNetbarInfo();
    this.requestBranchInfo();
  },
  methods: {
    requestNetbarInfo(){
      // 注释
      // alert(JSON.parse(sessionStorage.getItem('loginInfo')))
       let type = JSON.parse(sessionStorage.getItem('loginInfo')).role
       console.log(type)
      if(type == 0) {
        this.internetBarId = this.$cookies.get('internetBarId')
      }else {
        this.internetBarId = this.$route.query.internetBarId
      }
      echonNetbarInfo({netBarId:this.internetBarId}).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.echoData = res.data;
          this.echoData.waPoliceStation = this.echoData.waPolicestation
          this.echoData.Id = this.echoData.siteId
          this.echoData.latlng =  this.echoData.latitude + ',' + this.echoData.longitude;
          if(this.$utils.getUrlKey('latng')){
            this.echoData.latlng =  this.$utils.getUrlKey('latng');
          }
        }
      });
    },
    //  保修类型的chaage事件
    onConfirm(value, index) {
      console.log(value);
      // 改变状态中的值
      this.echoData.siteState = value.siteState;
      this.statusShow = false;
    },
    // 点击取消的时候隐藏
    onCancel() {
      this.statusShow = false;
    },
    onNavClick(index) {
       console.log(index)    
        // 获取分区的ID,通过ID去找到当前的派出所
        let substationCode = this.items[index].activeId
        console.log(substationCode)
        this.echoData.waDepartment = substationCode
        this.requestPoliceList(substationCode)
        // this.index.activeId
    },
    onItemClick(policeName,policeCode) {
        // 获取派出所的文本信息
        console.log(policeCode)
        this.policeCode = policeCode
        // 改变页面上派出所状态
        this.echoData.policeName = policeName
        // 传的waPoliceStation参数
        this.echoData.waPoliceStation = policeCode
    },
    onPoliceClick() {
       this.policeShow = false
    },
    // 是否展示营业状态类型
    handleBusinessStatusShow: function() {
      this.statusShow = !this.statusShow;
      // 设置状态
      if (this.statusShow) {
        this.columns = [
          {
            siteState: 1,
            text: "装机开业"
          },
          {
            siteState: 2,
            text: "装机停业"
          },
          {
            siteState: 3,
            text: "未装机开业"
          },
          {
            siteState: 4,
            text: "未装机停业"
          },
          {
            siteState: 5,
            text: "其他"
          }
        ];
      }
    },
    //是否展示派出所选择
    handlePoliceShow() {
      this.policeShow = !this.policeShow;
   
    },
    //跳转选择经纬度
    handleSelectLatlng(){
          let backUrl = 'https://kf.qingruilin.com.cn/infomanagement';
          console.log("222222====",backUrl);
          let url = 'http://apis.map.qq.com/tools/locpicker?search=1&type=0&backurl='+encodeURI(backUrl)+'&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp'
          // let url = 'http://apis.map.qq.com/tools/locpicker?search=1&type=0&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp'
          window.location.href = url

    },
    // 请求分局
    requestBranchInfo() {
      branchInfo().then(res => {
        let branchList = res.data;
        branchList.forEach(element => {
           this.items.push({
              activeId:element.substationCode,
              text:element.substationName
           })
        });
        // 默认加载分区的第一个index 
        let substationCode = this.items[0].activeId
        this.echoData.waDepartment = substationCode
        // 默认加载派出所列表
        this.requestPoliceList(substationCode);
      });
    },
    // 派出所列表
    requestPoliceList(substationCode) {
      PoliceList({substationCode:substationCode}).then(res=>{
        console.log(res)
        this.policeList = res.data
      })
    },
    // 点击保存事件
    handleSaveNetbarInfo() {
      this.reqeustNetbarInfo();
    },
    // 保存网吧信息
    reqeustNetbarInfo() {
      let echoData = this.echoData
       if(!echoData.siteName) {
          Toast('场所名称不能为空')
          return false
       }
       if(!echoData.siteAddress) {
          Toast('场所地址不能为空')
          return false 
       }
        if(!echoData.principalTel) {
          Toast('场所联系电话不能为空')
          return false 
       }
        if(!echoData.siteState) {
          Toast('营业状态不能为空')
          return false 
       }
        if(!echoData.infomanName) {
          Toast('负责人姓名不能为空')
          return false 
       }
        if(!echoData.principalName) {
          Toast('安全员姓名不能为空')
          return false 
       }
        if(!echoData.principalTel) {
          Toast('负责人联系电话不能为空')
          return false 
      }
        if(!echoData.principalEmail) {
          Toast('负责人邮箱不能为空')
          return false 
      }
       if(!echoData.netterminalsNum) {
          Toast('上网终端数量不能为空')
          return false 
      }
      if(!echoData.connectmode) {
          Toast('运营商不能为空')
          return false 
      }
      if(!echoData.waDepartment) {
          Toast('分局不能为空')
          return false 
      }
      if(!echoData.waPoliceStation) {
          Toast('派出所不能为空')
          return false 
      }
      if(!echoData.fromIp) {
          Toast('起始IP不能为空')
          return false 
      } 
      if(!echoData.toIp) {
          Toast('结束IP不能为空')
          return false 
      } 
      if(!echoData.securitySoftwareOrgcode) {
          Toast('组织机构代码不能为空')
          return false 
      }
      if(!echoData.securitySoftwareOrgname) {
          Toast('厂家名称不能为空')
          return false 
      }
      netbarInfo(echoData).then(res => {
        console.log(res)
        if(res.code==200) {
          this.$router.go(-1)
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  .active {
    color: #008cff !important;
  }
  .info-management {
    width: 100%;
    background-color: #ffffff;
    margin-top: 10px;
  }
  // 输入信息管理
  .place-name {
    width: 100%;
    height: 50px;
    padding: 13px;
    box-sizing: border-box;
    font-size: 15px;
    color: #333333;
    border-bottom: 1px solid #f2f2f2;
    // span 文本框内容
    span {
      display: inline-block;
      &:first-child {
        margin-top: 4px;
        text-align: left;
        float: left;
      }
      &:last-child {
        float: right;
      }
      img {
        width: 8px;
        height: 14px;
        vertical-align: middle;
        margin-left: 5px;
      }
      input {
        width: 240px;
        border: none;
        // direction: rtl;
        line-height: normal;
        text-align: right;
        &::-webkit-input-placeholder {
          color: #999999;
        }
      }
    }
    // 选择图标
    .select {
      // display: inline-block;
      color: #999999;
      //   vertical-align: middle;
    }
  }
  // 输入代码
  // 系统关键名称
  .place-code {
    width: 100%;
    height: 79px;
    padding: 0 13px;
    box-sizing: border-box;
    font-size: 15px;
    color: #333333;
    text-align: left;
    border-bottom: 1px solid #f2f2f2;
    div {
      &:last-child {
        margin-top: 17px;
      }
      input {
        border: none;
        &::-webkit-input-placeholder {
          color: #999999;
        }
      }
    }
  }
  // 点击保存
  .btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    margin: 65px auto;
    text-align: center;
  }
  // 营业状态
  .select-type {
    width: 100%;
    position: fixed;
    bottom: 0;
  }
  // 选择派出所
  .right-content {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    li {
      font-size: 15px;
      color: #000000;
      text-align: left;
      height: 44px;
      line-height: 44px;
    }
  }
}
</style>
<style lang="scss">
.van-picker__cancel {
  color: #333333;
  font-size: 17px;
}
.van-picker__confirm {
  color: #333333;
  font-size: 17px;
}
.van-sidebar-item--select {
  border-color: #008fff;
  color: #008fff;
}
</style>